import { useDashboardContext } from '@/store/contexts/DashboardContext'

/**
 * Dashboard 관련 Custom Hook
 * DashboardContext를 래핑하여 사용하기 편리하게 만듦
 */
export function useDashboard() {
  return useDashboardContext()
}

